"use client"

import type React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { ThemeProvider, createTheme, CssBaseline, GlobalStyles } from "@mui/material"
import HomePage from "./pages/HomePage"
import ToolsPage from "./pages/ToolsPage"
import "./App.css"

// Crear un tema personalizado con los colores de la marca
const theme = createTheme({
  palette: {
    primary: {
      main: "#0d6336",
    },
    secondary: {
      main: "#3c2a20",
    },
    background: {
      default: "#d7ddd1",
      paper: "#ffffff",
    },
    text: {
      primary: "#3c2a20",
      secondary: "#0d6336",
    },
  },
  typography: {
    fontFamily: "'Montserrat', 'Roboto', sans-serif",
    h1: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 600,
    },
    h2: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 600,
    },
    h3: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 500,
    },
    body1: {
      fontFamily: "'Roboto', sans-serif",
    },
    button: {
      fontFamily: "'Roboto', sans-serif",
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          padding: "10px 20px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        },
      },
    },
  },
})

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={{
        'html, body': {
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          overflow: '-moz-scrollbars-none',
        },
        '*': {
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        },
      }} />
      <div className="app">
        <Router>
          <Routes>
            <Route path="/tools/*" element={
              <ToolsPage />
            } />
            <Route path="/" element={<HomePage />} />
          </Routes>
        </Router>
      </div>
    </ThemeProvider>
  )
}

export default App
